module.exports = __webpack_public_path__ + "static/media/wikipedia.cd8700e6.jpg";